import React, { useRef, useState } from 'react';
import * as S from './Styles';
import Frame from '../Frame';
import SVG from '../SVG';

interface CollapseProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  transition?: number;
}

const Collapse = ({ title, children, transition = 200 }: CollapseProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const frameRef = useRef<HTMLLabelElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };
  React.useEffect(() => {
    if (frameRef.current) {
      setContentHeight(frameRef.current.clientHeight);
    }
  }, [children]);
  return (
    <S.CollapseContainer>
      <S.CollapseHeader isOpen={isOpen}>
        <S.CollapseTitle>{title}</S.CollapseTitle>
        <S.CollapseIconContainer onClick={toggleCollapse}>
          {isOpen ? <SVG.Icon.Minus /> : <SVG.Icon.Plus />}
        </S.CollapseIconContainer>
      </S.CollapseHeader>
      <S.CollapseContent
        isOpen={isOpen}
        transition={transition}
        height={contentHeight}
      >
        {children}
        <Frame ref={frameRef}>{children}</Frame>
      </S.CollapseContent>
    </S.CollapseContainer>
  );
};

export default Collapse;
